import React,{Component} from 'react';
import {createMarkup} from './Factory';
import Flexbox from '../components/misc/Flexbox'; 
import PressImage from '../components/PressImage'; 
import Masonry from 'react-masonry-component';
import downloadicon from '../images/download.svg';
import downloadiconblack from '../images/download-black.svg';

class PresseNeuigkeiten extends Component {
    constructor(props) {
		super(props);
		this.state = { 
			cycle:''
		}
	}
	handlePrevious(id){
		let image_id = "image_id_"+Number(id-1);
		let imageElement = document.getElementById(image_id)
		if (imageElement) 
			imageElement.click();
	}
	handleNext(id){
		let image_id = "image_id_"+Number(id+1);
		let imageElement = document.getElementById(image_id)
		if (imageElement) 
			imageElement.click();
	}
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	componentDidMount(){	 
		setTimeout(function(){
			document.getElementById('submenu-neuigkeiten').classList.add('active');
			document.getElementById('menu-presse').classList.add('active');
		},400);
	}
	componentWillUnmount(){
		document.getElementById('submenu-neuigkeiten').classList.remove('active');
		document.getElementById('menu-presse').classList.remove('active');	
	}
	render(){				
		const { 
			title,date,content,
			download_text,press_file,press_label,pressemappe,press_image,press_image_heading,press_image_text	
		} = this.props;	 
		
		return(
			<div>	
				<article className="col-md-8 article-full">
					<h1 dangerouslySetInnerHTML={createMarkup(title)}></h1>
					 <div className="times">
						<time dateTime={date}>{date} </time>
					 </div>	
					<p dangerouslySetInnerHTML={createMarkup(content)}></p>
				</article>
				{
				(pressemappe || press_file) ?
				<aside className="col-md-4 sidebar article-list">				
					<div className="press-material txt-block sidebar-block">
						<Flexbox left="Down" right="loads" />
						<p dangerouslySetInnerHTML={createMarkup(download_text)}></p>
						{
						(pressemappe) ?
							<a href={pressemappe} target="_blank" className="btn dark-btn margin-top-30">
								Gesamte Pressemappe
								<img src={downloadicon} alt="download" />
							</a>
						:null
						}
						{
						(press_file)?
							<ul className="margin-top-20 press_downloads">
								{
								press_label.map( (data,i)=>
									<li key={i} >
										<a target="_blank" href={press_file[i]} >
											{data}
											<img className="download_icon" src={downloadiconblack} alt="download" />
										</a>										
									</li>
									)
								}	
							</ul>
						:null
						}
					</div>
				</aside>
				:null
				}
				{
				(press_image)?	
					<div className="col-md-12">
						<div className="row">
							<Masonry updateOnEachImageLoad={true} className="press_image_gallery">
								{														
									press_image.map( (data,i)=>
										<PressImage 
												handleNext={this.handleNext}
												handlePrevious={this.handlePrevious}
												key={i} id={i} image={data} heading={press_image_heading[i]} desc={press_image_text[i]} />
									)	
								}
							</Masonry>
						</div>
					</div>
				:null
				}
			</div>
				
		)
	}
}
export default PresseNeuigkeiten; 


// WEBPACK FOOTER //
// ./src/components/PresseNeuigkeiten.js